import { AnalyticsDataLayer } from './../../../../services/analytics/definitions/analytics.interface';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmRegistration, ConfirmRegistrationState } from './definitions';
import { ConfirmRegistrationService } from './confirm-registration.service';
import { RegistrationService } from '../../registration.service';
import { KngLoaderState } from 'kinetic-angular';
import { Icons, IsRequestSubmittedForReview } from '../../../../services/shared/shared-enums';
import { SharedService } from 'projects/tmhna-portal/src/app/services/shared/shared.service';

@Component({
	selector: 'tmhna-portal-confirm-registration',
	templateUrl: './template/confirm-registration.component.html',
	styleUrls: ['./template/confirm-registration.component.scss']
})
export class ConfirmRegistrationComponent implements ConfirmRegistration, OnInit, OnDestroy
{
	private readonly subscriptions: Subscription = new Subscription();
	public loaderState: KngLoaderState = {
		imagePath: Icons.loaderWhite
	};
    @Input() set state(value: ConfirmRegistrationState)
	{
		this.service.updateState(value);
	}
    get state(): ConfirmRegistrationState
    {
    	return this.service.state;
    }

    @Output() stateChanged: EventEmitter<ConfirmRegistrationState> = new EventEmitter<ConfirmRegistrationState>();

    constructor(
        private readonly service: ConfirmRegistrationService, private readonly registrationService: RegistrationService, public sharedService: SharedService
    ) { }

    ngOnInit(): void
    {
    	this.state.loading = true;
    	this.registrationService.canActivatePortal()?.then(()=>
    	{
    		setTimeout(() =>  
    		{ 
    			this.state.loading = false;
    			const confirmReg = document.getElementById('confirm-registration');
    			if (confirmReg) 
    			{
    				confirmReg.focus();
    				this.sharedService.scrollToTopOfPage();
    			}
    		}, 1000);
    	}).catch(() => 
    	{
    		setTimeout(() =>  { this.state.loading = false; }, 1000);
    	}); 
    	this.service.getPageLabels();
    	this.service.getFooterData();
    	this.initSubscriptions();
    	const analyticsData: AnalyticsDataLayer = {
    		event: 'pageView',
    		page: {
    			name: 'registration:email sent',
    			type: 'login'
    		}
    	};
    	this.service.trackAnalyticsEvent(analyticsData);
    }
    ngOnDestroy(): void
    {
    	this.destroySubscriptions();
    }
    public refreshPage(): void
    {	
    	this.service.navigateForUserRegistrationStatus();
    }

    private initSubscriptions(): void
    {
    	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
    		(next: ConfirmRegistrationState) => this.stateChanged.emit(next)
    	);
    	this.subscriptions.add(stateChangeSubs);
    }
    private destroySubscriptions(): void
    { 
    	localStorage.removeItem(IsRequestSubmittedForReview.isRequestSubmittedForReview);
    	this.subscriptions.unsubscribe();
    }
}
